import { render, staticRenderFns } from "./ProcedureDeviationModal.vue?vue&type=template&id=074da16b&scoped=true"
import script from "./ProcedureDeviationModal.vue?vue&type=script&lang=js"
export * from "./ProcedureDeviationModal.vue?vue&type=script&lang=js"
import style0 from "./ProcedureDeviationModal.vue?vue&type=style&index=0&id=074da16b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074da16b",
  null
  
)

export default component.exports